import React from 'react';
import Button from '@mui/material/Button';
import TimerIcon from '@mui/icons-material/Timer';

const ReportCountdownButton = ({ onClick, name = 'Report Countdown Timer', icon = <TimerIcon />, sx = {}, ...props }) => (
  <Button
    variant="contained"
    onClick={onClick}
    startIcon={icon || undefined}
    sx={{
      background: 'linear-gradient(180deg, #4CAF50 0%, #2E7D32 100%)',
      width: 160,
      height: 50,
      borderRadius: '10px',
      color: '#fff',
      textTransform: 'none',
      fontFamily: 'DM Sans',
      fontWeight: 600,
      fontSize: '12px',
      '&:hover': {
        background: 'linear-gradient(180deg, #45A049 0%, #1B5E20 100%)',
      },
      ...sx,
    }}
    {...props}
  >
    {name}
  </Button>
);

export default ReportCountdownButton;